import {playFilledSvg as Icon__small__playFilledSvg} from '../Icon__small/Icon__small--playFilled.js';
import {playFilledSvg as Icon__xsmall__playFilledSvg} from '../Icon__xsmall/Icon__xsmall--playFilled.js';
import {playFilledSvg as Icon__xxsmall__playFilledSvg} from '../Icon__xxsmall/Icon__xxsmall--playFilled.js';

export var playFilled = {
  name: 'playFilled',
  category: 'icon',
  colorable: true,
  svg: Icon__small__playFilledSvg,
  alt: {
    Icon__small: Icon__small__playFilledSvg,
    Icon__xsmall: Icon__xsmall__playFilledSvg,
    Icon__xxsmall: Icon__xxsmall__playFilledSvg,
  },
  combined: ['Icon__small', 'Icon__xsmall', 'Icon__xxsmall'],
};
